import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { GetDate, GetTime } from '../../../app/AppUtils';
import DefaultExcelExport from '../../subcomponents/DefaultExcelExport';

export default function ExportExcelWintersport({ disabled, jsonData }) {
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    const [excelDataRows, setExcelDataRows] = useState([]);
    const [excelHeaderRow, setExcelHeaderRow] = useState([]);
    const [excelTitleRows, setExcelTitleRows] = useState([]);
    const [excelFileName, setExcelFileName] = useState("");

    useEffect(() => {
        if (jsonData) {
            let data = jsonData?.students?.map(({ studentId, ...rest }) => rest);

            // Title rows
            setExcelTitleRows([
                [`${resourceFinal[appLanguage].words.CLASS}: ${jsonData.schoolClassName}`],
                [`${resourceFinal[appLanguage].words.ACTIVITY}: ${jsonData.activityName}`],
                [`${resourceFinal[appLanguage].words.PERFORMANCE}: ${jsonData.performanceName}`],
                [`${resourceFinal[appLanguage].words.START}${resourceFinal[appLanguage].words.TIME.toLowerCase()}: ${GetDate(jsonData.startTime)} (${GetTime(jsonData.startTime)})`]
            ]);

            // Header row
            setExcelHeaderRow([
                resourceFinal[appLanguage].words.NAME_FIRST,
                resourceFinal[appLanguage].words.NAME_INSERTION,
                resourceFinal[appLanguage].words.NAME_LAST,
                resourceFinal[appLanguage].words.USER_DATA_BIRTHDATE,
                resourceFinal[appLanguage].words.USER_DATA_SPORT,
                resourceFinal[appLanguage].words.USER_DATA_HEIGHT,
                resourceFinal[appLanguage].words.USER_DATA_WEIGHT,
                resourceFinal[appLanguage].words.USER_DATA_SHOE_SIZE,
                resourceFinal[appLanguage].words.USER_DATA_SKIEXPERIENCE,
                resourceFinal[appLanguage].words.USER_DATA_OWNED_MATERIAL,
                resourceFinal[appLanguage].words.USER_DATA_GENDER,
                resourceFinal[appLanguage].words.USER_DATA_MEDICATION,
                resourceFinal[appLanguage].words.USER_DATA_EMAIL_PRIVATE,
                resourceFinal[appLanguage].words.USER_DATA_PHONENUMBER,
                resourceFinal[appLanguage].words.USER_DATA_ALLERGY,
                resourceFinal[appLanguage].words.USER_DATA_EMERGENCY_CONTACT_NAME,
                resourceFinal[appLanguage].words.USER_DATA_EMERGENCY_CONTACT_NUMBER,
            ]);

            // Data rows
            let dataRows = [];

            data?.forEach(item => {
                dataRows.push(
                    Object.keys(item).map(key => {
                        const value = item[key];

                        if (key.toLowerCase().includes("date")) {
                            return value === null ? "" : `${GetDate(value)}`;
                        }

                        return value === null ? "" : value;
                    })
                );
            });

            setExcelDataRows(dataRows);

            // File name
            setExcelFileName(`${resourceFinal[appLanguage].words.REPORT_WINTERSPORT}: ${jsonData.activityName} - ${jsonData.performanceName}`);
        }
    }, [jsonData]);

    return (
        <DefaultExcelExport
            titleRows={excelTitleRows}
            headerRow={excelHeaderRow}
            dataRows={excelDataRows}
            fileName={excelFileName}
            buttonText={`${resourceFinal[appLanguage].words.EXPORT} ${resourceFinal[appLanguage].words.EXCEL.toLowerCase()}`}
            disabledCondition={disabled}
        />
    );
}
